import { render, staticRenderFns } from "./AiSettings.vue?vue&type=template&id=4f9960cc&scoped=true"
import script from "./AiSettings.vue?vue&type=script&lang=js"
export * from "./AiSettings.vue?vue&type=script&lang=js"
import style0 from "./AiSettings.vue?vue&type=style&index=0&id=4f9960cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9960cc",
  null
  
)

export default component.exports